import { graphql, useStaticQuery } from 'gatsby'

export interface SiteMetadataCompany {
  longName: string
  shortName: string
  managingDirector: string
  mailingAddress: string
  vatId: string
  registerCourt: string
  registerNumber: string
}

export interface SiteMetadataMarketing {
  googleAnalyticsId?: string
  googleTagManagerId?: string
  intercomAppId?: string
  navatticId?: string
  segmentId?: string
  firstPromoterId?: string
  firstPromoterDomain?: string
  profitWellRetainAuth?: string
  upscribeId?: string
}

export interface SiteMetadata {
  siteUrl: string
  title: string
  company: SiteMetadataCompany
  contactEmail: string
  marketing: SiteMetadataMarketing
}

export function useSiteMetadata() {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          siteUrl
          title
          company {
            longName
            shortName
            managingDirector
            mailingAddress
            vatId
            registerCourt
            registerNumber
          }
          contactEmail
          marketing {
            firstPromoterId
            firstPromoterDomain
            intercomAppId
            navatticId
            profitWellRetainAuth
            segmentId
          }
        }
      }
    }
  `)
  return data.site.siteMetadata as SiteMetadata
}
